import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const ErfaringsbasertDim: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='66'
			height='82'
			viewBox='0 0 66 82'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Frame 3' clipPath='url(#clip0_2333_40233)'>
				<rect
					id='Rectangle 2979'
					x='13'
					y='13'
					width='52'
					height='68'
					fill='white'
					stroke='#444F55'
					strokeWidth='2'
				/>
				<rect
					id='Rectangle 2978'
					x='6'
					y='6'
					width='53'
					height='69'
					fill='white'
					stroke='#444F55'
					strokeWidth='2'
				/>
				<rect
					id='Rectangle 2977'
					x='1'
					y='1'
					width='52'
					height='68'
					fill='white'
					stroke='#444F55'
					strokeWidth='2'
				/>
				<line id='Line 1579' x1='7' y1='29' x2='23' y2='29' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1585' x1='7' y1='33' x2='23' y2='33' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1586' x1='7' y1='38' x2='23' y2='38' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1587' x1='7' y1='43' x2='23' y2='43' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1588' x1='7' y1='48' x2='23' y2='48' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1581' x1='7' y1='9' x2='18' y2='9' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1582' x1='7' y1='14' x2='47' y2='14' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1583' x1='7' y1='19' x2='47' y2='19' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1584' x1='7' y1='24' x2='47' y2='24' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1590' x1='7' y1='53' x2='47' y2='53' stroke='#FF9600' strokeWidth='2' />
				<line id='Line 1591' x1='7' y1='57' x2='47' y2='57' stroke='#FF9600' strokeWidth='2' />
				<rect
					id='Rectangle 2980'
					x='27'
					y='29'
					width='19'
					height='19'
					stroke='#FF9600'
					strokeWidth='2'
				/>
			</g>
			<defs>
				<clipPath id='clip0_2333_40233'>
					<rect width='66' height='82' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
